import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map, publishReplay, refCount } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AppSettingsService {
  constructor(private httpClient: HttpClient) {}

  getPageJson<T>(jsonPath: string): Observable<T> {
    if (jsonPath.indexOf('assets') === -1) {
      jsonPath = 'assets/' + jsonPath;
    }
    return this.httpClient.get<T>(jsonPath).pipe(
      catchError((err) => {
        throw new Error('Error while reading Json ' + err);
      })
    );
  }

  getAppSettings<T>(jsonPath: string) {
    if (jsonPath.indexOf('assets') === -1) {
      jsonPath = 'assets/' + jsonPath;
    }
    return this.httpClient.get<T>(jsonPath).pipe(
      catchError((err) => {
        throw new Error('Error while reading Json ' + err);
      })
    );
  }
}
